import { SilentError } from './SilentError';

/**
 * Error, that should not be tracked, handled in any scope
 */
export class RequestCancel extends SilentError {
    isCancel = true;

    constructor(...args) {
        super(...args);
        this.name = 'RequestCancel';
    }
}
